import React, {createContext, type PropsWithChildren, useContext} from 'react'
import {type GameModeTranslationKeyContext} from '@colonist/i18n'

interface UIGameTranslationContextValue {
    translationKeyContext: GameModeTranslationKeyContext
}

const UIGameTranslationContext = createContext<UIGameTranslationContextValue | undefined>(undefined)

export type UIGameTranslationProviderProps = PropsWithChildren<{
    translationKeyContext: GameModeTranslationKeyContext
}>

export const UIGameTranslationProvider = ({children, translationKeyContext}: UIGameTranslationProviderProps) => (
    <UIGameTranslationContext.Provider value={{translationKeyContext: translationKeyContext}}>
        {children}
    </UIGameTranslationContext.Provider>
)

export const useUIGameTranslationContext = () => {
    const context = useContext(UIGameTranslationContext)
    if(!context) throw new Error('UIGameTranslationContext not found')
    return context
}
